(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.html',
    '<!DOCTYPE html><html><head lang="en"><meta charset="UTF-8"><title></title></head><body></body></html>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.js